var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS1Kreis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "s1kreis",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_33",
    "data-name": "Rechteck 33",
    width: 150,
    height: 150,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_143",
    "data-name": "Gruppe 143",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 38.7,
    cy: 38.7,
    r: 38.7,
    transform: "translate(36.3 36.3)",
    fill: "#0abae6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_43",
    "data-name": "Rechteck 43",
    width: 150,
    height: 150,
    transform: "translate(-1 3)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_473",
    "data-name": "Pfad 473",
    d: "M48.2,81.8H55c.6,4.1,2.6,5.6,7.6,5.6,3.5,0,6.5-1.2,6.5-4.4s-3.2-3.8-8.2-5C55,76.5,49.4,75.1,49.4,68c0-6.8,5.3-10,12.9-10s12.4,3.8,12.9,10.6H68.7c-.3-3.5-2.9-5-6.5-5S56,65.1,56,67.4c0,2.6,2.4,3.5,7.4,4.7C70.5,73.6,76,75.3,76,82.4,76,89.2,70.4,93,62.8,93,53.5,92.9,48.5,88.8,48.2,81.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_474",
    "data-name": "Pfad 474",
    d: "M90.2,69.1h-7V65.6c3.5,0,7-1.2,8.2-5.9h5.9V92.5h-7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_472",
    "data-name": "Pfad 472",
    d: "M75,41a32.688,32.688,0,0,1,32.8,32.576V73.8c0,17.6-15.2,34-32.8,34s-32.8-15.2-32.8-34h0A32.751,32.751,0,0,1,74.9,41H75m0-4.7A38.7,38.7,0,1,0,113.7,75h0A38.348,38.348,0,0,0,75.708,36.3Z",
    fill: "#0abae6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS1Kreis);
export default __webpack_public_path__ + "static/media/s1kreis.6f41f6f537e1095ed6abd141face2961.svg";
export { ForwardRef as ReactComponent };